export const getInitialState = () => ({
  professionalData: null,
  isElegibleProfessionalStep: false,
});

export const state = getInitialState();
